var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/extensions/YoutubeExtenions.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-hr.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement } from "lit/decorators.js";
import { BaseYoutube } from "../../db/extensions/BaseYoutube.js";
import "../components/x-buildify-permission-selection.js";
import "../components/x-buildify-spacing-picker.js";
import { ExtensionBoilerplate } from "./ContentExtensionBoilerplate.js";
var YoutubeExtension = {
  class: BaseYoutube,
  toolbar: { icon: "youtube_activity", text: { default: "Youtube" } },
  render(instance, { defaultValues, isSubelement, dropzoneBefore, dropzoneAfter }) {
    return html`
      <x-youtube-extension
        .content=${instance}
        .defaultValues=${defaultValues}
        ?sub=${isSubelement}
        .hasDropzoneBefore=${dropzoneBefore}
        .hasDropzoneAfter=${dropzoneAfter}
      ></x-youtube-extension>
    `;
  },
  editor({ content, contentController, controllerBaseKeyPath }) {
    return html`
      <x-flex space="md">
        <x-input placeholder="Youtube ID" ${contentController.field(...controllerBaseKeyPath, "youtubeID")}></x-input>
      </x-flex>
    `;
  },
  group: "Medien"
};
var XYoutubeExtension = class extends ExtensionBoilerplate {
  _content(content) {
    return this._player(content.youtubeID);
  }
  _player(id) {
    return html`
      <iframe
        src=${`https://www.youtube.com/embed/${id}`}
        width="100%"
        ${css({ aspectRatio: "16 / 9", borderRadius: this.defaultValue("borderRadius", { global: "5px" }) })}
        frameborder="0"
        allow="autoplay; fullscreen"
        allowfullscreen
      ></iframe>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          width: "100%"
        }
      }
    ];
  }
};
XYoutubeExtension = __decorateClass([
  customElement("x-youtube-extension")
], XYoutubeExtension);
export {
  XYoutubeExtension,
  YoutubeExtension
};
